<div class="w-full flex flex-col pt-5 gap-md">
  <div class="flex items-center justify-between">
    <span class="text-4xl font-bold">
      {{ "MasterData.Currencies.Title" | i18nextEager }}
    </span>
    @if (userInfoService.isSuperAdmin()) {
      <doka-button icon="add" (click)="createCurrency()">
        <ng-template #text>
          {{ "MasterData.Currencies.NewCurrency" | i18nextEager }}
        </ng-template>
      </doka-button>
    }
  </div>

  <doka-search-field (valueChange)="searchText.set($event)" [placeholder]="'Common.Search' | i18nextEager" />

  @if (currencies.isLoading() || countries.isLoading()) {
    <app-spinner />
  } @else {
    <doka-table>
      <doka-thead>
        <doka-tr>
          <doka-th>{{ "MasterData.Currencies.Code" | i18nextEager }}</doka-th>
          <doka-th>{{ "MasterData.Currencies.Symbol" | i18nextEager }}</doka-th>
          <doka-th>{{ "MasterData.Currencies.Countries" | i18nextEager }}</doka-th>
          <doka-th />
        </doka-tr>
      </doka-thead>
      <doka-tbody>
        @for (currency of filteredCurrencies(); track currency.isoCurrencyCode) {
          <doka-tr>
            <doka-td>{{ currency.isoCurrencyCode }}</doka-td>
            <doka-td>{{ currency.currencySymbol }}</doka-td>
            <doka-td>
              @let assigned = assignedCountries(currency.isoCurrencyCode);
              @for (country of assigned.slice(0, maxVisibleCountries); track country.id; let last = $last) {
                {{ country.countryName }} ({{ country.countryCode
                }}){{ !last ? ", " : assigned.length > maxVisibleCountries ? ", ..." : "" }}
              } @empty {
                -
              }
            </doka-td>
            <doka-td>
              <div class="flex justify-end">
                <a
                  class="action-icon"
                  [title]="'Common.Edit' | i18nextEager"
                  role="button"
                  (click)="editCountries(currency)"
                >
                  <doka-icon name="edit" />
                </a>
              </div>
            </doka-td>
          </doka-tr>
        }
      </doka-tbody>
    </doka-table>
  }
</div>
